import { useAdaptiveRtStore } from '@/stores/adaptiveRtStore';
import { isAdaptiveRtHistoryParams } from '@/utils/adaptiveRtHistory';
import { isAdaptiveRtModule } from '@/utils/adaptiveRtModule';
import { fetchAdaptiveRtCommonStructures } from '@/api/modules/calculatorApi';
import { aliasGroupsToApiPayload } from '@/utils/adaptiveRtStructureAliases';

/**
 * Восстановление AdaptiveRT из payload истории (runRecords / Pinia restore store).
 * @param {Array<object>|null|undefined} runRecords
 * @returns {Promise<boolean>} true, если store заполнен
 */
export async function restoreAdaptiveRtFromRunRecords(runRecords) {
  if (!runRecords?.length) return false;
  const store = useAdaptiveRtStore();
  const tcpRec = runRecords.find((r) => r.model_type === 'TCP');
  const ntcpRec = runRecords.find((r) => r.model_type === 'NTCP');
  const tcpParams = tcpRec?.params;
  const ntcpParams = ntcpRec?.params;
  const hasTcp = isAdaptiveRtHistoryParams(tcpParams);
  const hasNtcp = isAdaptiveRtHistoryParams(ntcpParams);
  if (!hasTcp && !hasNtcp) return false;

  if (hasTcp) store.restoreTcpFromHistory(tcpParams);
  if (hasNtcp) store.restoreNtcpFromHistory(ntcpParams);

  const planIds = store.planIds;
  if (planIds.length) {
    try {
      const body = { plan_ids: planIds };
      const aliases = aliasGroupsToApiPayload(store.structureAliasGroups);
      if (aliases.length) body.structure_aliases = aliases;
      const data = await fetchAdaptiveRtCommonStructures(body);
      store.setCommonStructures(data.structures || []);
    } catch {
      // планы могли быть удалены — UI покажет ошибку при расчёте
    }
  }
  return true;
}

/**
 * @param {object|null|undefined} payload — { mode, runRecords, ... }
 */
export async function restoreAdaptiveRtFromHistoryPayload(payload) {
  if (!payload || !isAdaptiveRtModule(payload.mode)) return false;
  return restoreAdaptiveRtFromRunRecords(payload.runRecords);
}
